// extracted by mini-css-extract-plugin
export var assigneeBadge = "_kt-0";
export var assigneeDetails = "_kt-1";
export var assigneeInfo = "_kt-2";
export var dropdownContainer = "_kt-4";
export var dropdownImage = "_kt-5";
export var editAssigneeInfo = "_kt-3";
export var editAssigneeModalContainer = "_kt-6";
export var hidden = "_kt-8";
export var input = "_kt-7";